/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções sobre os Exames solicitados
 * @author Diego Sabino Amorim de Araújo
 * @file examesSolicitadosReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import * as actionTypes from 'actions'
import types from 'utils/actionTypes'

const initialState = {
  exameSolicitado: [],
  examesSolicitadosDosSetoresDoUsuario: [],
  examesSolicitadosPendentesDosSetoresDoUsuario: [],
  examesSolicitadosEmAndamentoDosSetoresDoUsuario: [],
  examinadoresCandidatos: [],
  processando: false,
  processandoExamesSolicitadosDosSetores: false,
  processandoExamesSolicitadosEmAndamentoDosSetores: false,
  processandoExamesSolicitadosPendentesDosSetores: false,
  permissaoAcoesExaminador: false,
  permissaoAssumirExame: false,
}

const examesSolicitadosReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PROCESSANDO_EXAME_SOLICITADO: {
      return {
        ...state,
        processando: action.isProcessando,
      }
    }

    case types.FETCH_EXAME_SOLICITADO: {
      return {
        ...state,
        exameSolicitado: action.exameSolicitado,
      }
    }

    case types.FETCH_EXAMES_SOLICITADOS_DOS_SETORES_DO_USUARIO: {
      return {
        ...state,
        examesSolicitadosDosSetoresDoUsuario: action.examesSolicitadosDosSetoresDoUsuario,
      }
    }

    case types.FETCH_EXAMES_SOLICITADOS_PENDENTES_DOS_SETORES_DO_USUARIO: {
      return {
        ...state,
        examesSolicitadosPendentesDosSetoresDoUsuario:
          action.examesSolicitadosPendentesDosSetoresDoUsuario,
      }
    }

    case types.FETCH_EXAMES_SOLICITADOS_EM_ANDAMENTO_DOS_SETORES_DO_USUARIO: {
      return {
        ...state,
        examesSolicitadosEmAndamentoDosSetoresDoUsuario:
          action.examesSolicitadosEmAndamentoDosSetoresDoUsuario,
      }
    }

    case actionTypes.SET_PROCESSANDO_EXAMES_SOLICITADOS_DO_SETOR: {
      return {
        ...state,
        processandoExamesSolicitadosDosSetores: action.processandoExamesSolicitadosDosSetores,
      }
    }

    case actionTypes.SET_PROCESSANDO_EXAMES_SOLICITADOS_PENDENTES_DO_SETOR: {
      return {
        ...state,
        processandoExamesSolicitadosPendentesDosSetores:
          action.processandoExamesSolicitadosPendentesDosSetores,
      }
    }

    case actionTypes.SET_PROCESSANDO_EXAMES_SOLICITADOS_EM_ANDAMENTO_DO_SETOR: {
      return {
        ...state,
        processandoExamesSolicitadosEmAndamentoDosSetores:
          action.processandoExamesSolicitadosEmAndamentoDosSetores,
      }
    }

    case types.SET_PERMISSAO_ACOES_EXAMINADOR: {
      return {
        ...state,
        permissaoAcoesExaminador: action.permissaoAcoesExaminador,
      }
    }
    case types.SET_PERMISSAO_ASSUMIR_EXAME: {
      return {
        ...state,
        permissaoAssumirExame: action.permissaoAssumirExame,
      }
    }

    case types.FETCH_EXAMINADORES_CADIDATOS: {
      return {
        ...state,
        examinadoresCandidatos: action.usuariosCandidatos,
      }
    }

    default: {
      return state
    }
  }
}

export default examesSolicitadosReducer
